export const ACS_BOOLEAN_OPTIONS = [
  { id: 0, name: 'Disabled' },
  { id: 1, name: 'Enabled' },
];

export const ACS_SRTP_OPTIONS = [
  { id: 0, name: 'AES_CM & ARIA_CM' },
  { id: 1, name: 'ARIA_CM & AES_CM' },
  { id: 2, name: 'AES_CM ONLY' },
  { id: 3, name: 'ARIA_CM ONLY' },
];

export const ACS_WAN_OPTIONS = [
  { id: 0, name: 'Off' },
  { id: 'wan', name: 'WAN1' },
  { id: 'wan2', name: 'WAN2' },
];

export const ACS_SWITCH_OPTIONS = [
  { id: 0, name: 'Off' },
  { id: 1, name: 'On' },
  { id: 2, name: 'AutoSwitch' },
];

export const ACS_METERING_FREQ_OPTIONS = [
  { id: 1, name: '12K' },
  { id: 0, name: '16K' },
];

export const ACS_DBID_SIP_TRANSPORT_OPTIONS = [
  { id: 0, name: 'UDP' },
  { id: 1, name: 'TCP' },
  { id: 2, name: 'TLS' },
];

export const ACS_DIAL_TONE_REGION = [
  { id: 1, name: 'Australia' },
  { id: 2, name: 'Austria' },
  { id: 3, name: 'Brazil' },
  { id: 4, name: 'Belgium' },
  { id: 5, name: 'China' },
  { id: 6, name: 'Czech' },
  { id: 7, name: 'Denmark' },
  { id: 8, name: 'Finland' },
  { id: 9, name: 'France' },
  { id: 10, name: 'Germany' },
  { id: 11, name: 'Britain' },
  { id: 12, name: 'Greece' },
  { id: 13, name: 'Hungary' },
  { id: 14, name: 'Lithuania' },
  { id: 15, name: 'India' },
  { id: 16, name: 'Italy' },
  { id: 17, name: 'Japan' },
  { id: 18, name: 'Korean' },
  { id: 19, name: 'Mexico' },
  { id: 20, name: 'New Zealand' },
  { id: 21, name: 'Netherlands' },
  { id: 22, name: 'Norway' },
  { id: 23, name: 'Portugal' },
  { id: 24, name: 'Spain' },
  { id: 25, name: 'Switzerland' },
  { id: 26, name: 'Sweden' },
  { id: 27, name: 'Russia' },
  { id: 28, name: 'USA' },
];

export const ACS_PROXY_DNS_TYPE = [
  { id: 0, name: 'A Type' },
  { id: 1, name: 'DNS SRV' },
  { id: 2, name: 'Auto' },
  { id: 3, name: 'DNS NAPTR' },
];

export const ACS_FAX_MODE_OPTIONS = [
  { id: 0, name: 'T.30' },
  { id: 1, name: 'T.38' },
  { id: 2, name: 'ByPass' },
];

export const ACS_DBID_FAX_BYPASS_ATTRIBUTE_VALUE_OPTIONS = [
  { id: 0, name: 'Fax' },
  { id: 1, name: 'Modem' },
  { id: 2, name: 'X-Fax' },
  { id: 3, name: 'X-Modem' },
];

export const ACS_DBID_FAX_BITRATE_OPTIONS = [
  { id: 14400, name: '14400' },
  { id: 9600, name: '9600' },
  { id: 4800, name: '4800' },
];

export const generateNumberOptions = (start: number, end: number, incrementation: number) => {
  const options: Array<{ id: number; name: string }> = [];
  for (let i = start; i <= end; i += incrementation) {
    options.push({ id: i, name: i.toString() });
  }
  return options;
};

export const ACS_DBID_SIP_USER_TYPE_OPTIONS = [
  { id: 0, name: 'IP' },
  { id: 1, name: 'PHONE' },
];

export const ACS_DBID_SIP_DTMF_MODE_OPTIONS = [
  { id: 0, name: 'Inband' },
  { id: 1, name: 'RFC2833' },
  { id: 2, name: 'SIP-INFO' },
  { id: 3, name: 'RFC2833+SIP-INFO' },
];

export const ACS_DBID_INFO_CONTENT_TYPE_OPTIONS = [
  { id: 0, name: 'Broadsoft' },
  { id: 1, name: 'Hook-Flash' },
  { id: 2, name: 'Telephone-Event' },
  { id: 3, name: 'Dtmfinfo+Xml ' },
  { id: 4, name: 'Dtmf-Relay' },
];

export const ACS_FORWARD_REVERSE_OPTIONS = [
  { id: 0, name: 'Forward' },
  { id: 1, name: 'Reverse' },
];

export const ACS_DBID_IMPEDANCE_MATCHING_OPTIONS = [
  { id: 0, name: 'US PBX,Korea,Taiwan (600)' },
  { id: 1, name: 'Standard (900)' },
  { id: 2, name: 'Japan CO (600+1uF)' },
  { id: 3, name: 'Bellcore (900+2.16uF)' },
  { id: 4, name: 'CTR21 (270+750||150nF)' },
  { id: 5, name: 'China CO (200+680||100nF)' },
  { id: 6, name: 'China PBX (200+560||100nF)' },
  { id: 7, name: 'Japan PBX (100+1000||100nF)' },
  { id: 8, name: 'India,New Zealand (370+620||310nF)' },
  { id: 9, name: 'Germany(Legacy) (220+820||115nF)' },
  { id: 10, name: 'UK(Legacy) (320+1050||230nF)' },
  { id: 11, name: 'Australia (220+820||120nF)' },
  { id: 12, name: 'Variation (600+2.16uF)' },
];

export const ACS_DBID_SIP_AUDIO_TYPE_OPTIONS = [
  { id: 0, name: 'G.711A' },
  { id: 1, name: 'G.711U' },
  { id: 2, name: 'G.722' },
  { id: 3, name: 'G.729' },
  { id: 4, name: 'G.723' },
  { id: 5, name: 'G.726-32+' },
  { id: 6, name: 'ILBC+' },
  { id: 7, name: 'AMR-WB' },
  { id: 8, name: 'PCMU-WB' },
  { id: 9, name: 'PCMA-WB' },
  { id: 10, name: 'AMR-NB' },
  { id: 11, name: 'OPUS' },
];

export const ACS_TZ_OPTIONS = [
  { id: 'UCT_-11', name: '(GMT-11:00) Midway Island, Samoa' },
  { id: 'UCT_-10', name: '(GMT-10:00) Hawaii' },
  { id: 'NAS_-09', name: '(GMT-09:00) Alaska' },
  { id: 'PST_-08', name: '(GMT-08:00) Pacific Time' },
  { id: 'MST_-07', name: '(GMT-07:00) Mountain Time' },
  { id: 'MSA_-07', name: '(GMT-07:00) Arizona' },
  { id: 'CST_-06', name: '(GMT-06:00) Central Time' },
  { id: 'UCT_-06', name: '(GMT-06:00) Middle America' },
  { id: 'UCT_-05', name: '(GMT-05:00) Indiana East, Colombia' },
  { id: 'EST_-05', name: '(GMT-05:00) Eastern Time' },
  { id: 'UCT_-04:30', name: '(GMT-04:30) Venezuela' },
  { id: 'AST_-04', name: '(GMT-04:00) Atlantic Time, Brazil West' },
  { id: 'UCT_-04', name: '(GMT-04:00) Guyana, Bolivia' },
  { id: 'UCT_-03:30', name: '(GMT-03:30) Newfoundland' },
  { id: 'EBS_-03', name: '(GMT-03:00) Brazil East, Greenland' },
  { id: 'NOR_-02', name: '(GMT-02:00) Mid-Atlantic' },
  { id: 'EUT_-01', name: '(GMT-01:00) Azores Islands' },
  { id: 'UCT_000', name: '(GMT) Gambia, Liberia, Morocco' },
  { id: 'GMT_000', name: '(GMT) England, Portugal' },
  { id: 'MET_001', name: '(GMT+01:00) Czech Republic, N' },
  { id: 'MEZ_001', name: '(GMT+01:00) Germany, Sweden, Denmark, Norway' },
  { id: 'UCT_001', name: '(GMT+01:00) Tunisia, Spain' },
  { id: 'EET_002', name: '(GMT+02:00) Greece, Ukraine, Turkey' },
  { id: 'SAS_002', name: '(GMT+02:00) South Africa' },
  { id: 'IST_003', name: '(GMT+03:00) Iraq, Jordan, Kuwait' },
  { id: 'MSK_003', name: '(GMT+03:00) Moscow' },
  { id: 'UCT_004', name: '(GMT+04:00) Baku, Armenia  and Iran' },
  { id: 'UCT_005', name: '(GMT+05:00) Pakistan, Russia' },
  { id: 'UCT_005:30', name: '(GMT+05:30) India' },
  { id: 'UCT_006', name: '(GMT+06:00) Bangladesh, Russia' },
  { id: 'UCT_007', name: '(GMT+07:00) Thailand, Russia' },
  { id: 'CST_008', name: '(GMT+08:00) China Coast, Hong Kong' },
  { id: 'CCT_008', name: '(GMT+08:00) Taipei' },
  { id: 'SST_008', name: '(GMT+08:00) Singapore' },
  { id: 'AWS_008', name: '(GMT+08:00) Australia (WA)' },
  { id: 'JST_009', name: '(GMT+09:00) Japan, Korea' },
  { id: 'KST_009', name: '(GMT+09:00) Korean' },
  { id: 'UCT_010', name: '(GMT+10:00) Guam, Russia' },
  { id: 'AES_010', name: '(GMT+10:00) Australia (QLD, TAS, NSW, ACT, VIC)' },
  { id: 'UCT_011', name: '(GMT+11:00) Solomon Islands' },
  { id: 'UCT_012', name: '(GMT+12:00) Fiji' },
  { id: 'NZS_012', name: '(GMT+12:00) New Zealand' },
];

export const ACS_INTERVALS_OPTIONS = [
  { id: 60, name: '1 minute' },
  { id: 2 * 60, name: '2 minutes' },
  { id: 5 * 60, name: '5 minutes' },
  { id: 10 * 60, name: '10 minutes' },
  { id: 15 * 60, name: '15 minutes' },
  { id: 30 * 60, name: '30 minutes' },
  { id: 60 * 60, name: '60 minutes' },
];

export const ACS_PORT_VALUES = [
  { name: 'DBID_ECHO_CANCEL_MGT', options: ACS_BOOLEAN_OPTIONS },
  { name: 'DBID_REG_FAIL_SET_SLIC_OPEN_MODE_ENABLE', options: ACS_BOOLEAN_OPTIONS },
  { name: 'DBID_SIP_EARLY_MEDIA_SUPPORT', options: ACS_BOOLEAN_OPTIONS },
  { name: 'DBID_SIP_P_EARLY_MEDIA_SUPPORT', options: ACS_BOOLEAN_OPTIONS },
  { name: 'DBID_CNG_DETECT_ENABLE', options: ACS_BOOLEAN_OPTIONS },
  { name: 'DBID_V21_DETECT_ENABLE', options: ACS_BOOLEAN_OPTIONS },
  { name: 'DBID_T38_REDUNDENCY', options: ACS_BOOLEAN_OPTIONS },
  { name: 'DBID_CED_DETECT_ENABLE', options: ACS_BOOLEAN_OPTIONS },
  { name: 'DBID_FAX_GPMD_ENABLE', options: ACS_BOOLEAN_OPTIONS },
  { name: 'DBID_REGIONAL_CPC_EN', options: ACS_BOOLEAN_OPTIONS },
  { name: 'DBID_SIP_CALLWAITING_ENABLE', options: ACS_BOOLEAN_OPTIONS },
  { name: 'DBID_SIP_CWCID_ENABLE', options: ACS_BOOLEAN_OPTIONS },
  { name: 'DBID_IDLE_POLARITY', options: ACS_FORWARD_REVERSE_OPTIONS },
  { name: 'DBID_POLARITY_REVERSAL_ENABLE', options: ACS_FORWARD_REVERSE_OPTIONS },
  { name: 'DBID_CALLER_POLARITY', options: ACS_FORWARD_REVERSE_OPTIONS },
  { name: 'DBID_INVOICE_NUM', options: [] },
  { name: 'DBID_OUTVOICE_NUM', options: [] },
  { name: 'DBID_DTMF_VOLUME', options: [] },
  { name: 'DBID_REGIONAL_CPC_DELAY', options: [] },
  { name: 'DBID_REGIONAL_CPC_DURATION', options: [] },
  { name: 'DBID_REGIONAL_RING_VOLTAGE', options: [] },
  { name: 'DBID_CODEC_OPEN_VOLTAGE', options: [] },
  { name: 'DBID_REGIONAL_RING_FREQUENCY', options: [] },
  { name: 'DBID_CODEC_LOOP_CURRENT', options: [] },
  { name: 'DBID_HOTLINE_NUMBER', options: null },
  { name: 'DBID_RFC_PAYLOAD', options: null },
  { name: 'DBID_MIN_JITTER_TIME', options: null },
  { name: 'DBID_MAX_JITTER_TIME', options: null },
  { name: 'DBID_SIP_TRANSPORT', options: ACS_DBID_SIP_TRANSPORT_OPTIONS },
  { name: 'DBID_FAX_BITRATE', options: ACS_DBID_FAX_BITRATE_OPTIONS },
  { name: 'DBID_SIP_USER_TYPE', options: ACS_DBID_SIP_USER_TYPE_OPTIONS },
  { name: 'DBID_SIP_DTMF_MODE', options: ACS_DBID_SIP_DTMF_MODE_OPTIONS },
  { name: 'DBID_INFO_CONTENT_TYPE', options: ACS_DBID_INFO_CONTENT_TYPE_OPTIONS },
  { name: 'DBID_SIP_AUDIO_TYPE1', options: ACS_DBID_SIP_AUDIO_TYPE_OPTIONS },
  { name: 'DBID_SIP_AUDIO_TYPE2', options: ACS_DBID_SIP_AUDIO_TYPE_OPTIONS },
  { name: 'DBID_SIP_AUDIO_TYPE3', options: ACS_DBID_SIP_AUDIO_TYPE_OPTIONS },
  { name: 'DBID_SIP_AUDIO_TYPE4', options: ACS_DBID_SIP_AUDIO_TYPE_OPTIONS },
  { name: 'DBID_SIP_AUDIO_TYPE5', options: ACS_DBID_SIP_AUDIO_TYPE_OPTIONS },
  { name: 'DBID_SIP_AUDIO_TYPE6', options: ACS_DBID_SIP_AUDIO_TYPE_OPTIONS },
  { name: 'DBID_SIP_AUDIO_TYPE7', options: ACS_DBID_SIP_AUDIO_TYPE_OPTIONS },
  { name: 'DBID_SIP_AUDIO_TYPE8', options: ACS_DBID_SIP_AUDIO_TYPE_OPTIONS },
  { name: 'DBID_SIP_AUDIO_TYPE9', options: ACS_DBID_SIP_AUDIO_TYPE_OPTIONS },
  { name: 'DBID_SIP_AUDIO_TYPE10', options: ACS_DBID_SIP_AUDIO_TYPE_OPTIONS },
  { name: 'DBID_SIP_AUDIO_TYPE11', options: ACS_DBID_SIP_AUDIO_TYPE_OPTIONS },
  { name: 'DBID_SIP_AUDIO_TYPE12', options: ACS_DBID_SIP_AUDIO_TYPE_OPTIONS },
  { name: 'DBID_IMPEDANCE_MATCHING', options: ACS_DBID_IMPEDANCE_MATCHING_OPTIONS },
  { name: 'DBID_FAX_BYPASS_ATTRIBUTE_VALUE', options: ACS_DBID_FAX_BYPASS_ATTRIBUTE_VALUE_OPTIONS },
  { name: 'DBID_SIGTONE_TYPE', options: ACS_DIAL_TONE_REGION },
  { name: 'DBID_DNSSRV_ENABLE', options: ACS_PROXY_DNS_TYPE },
  { name: 'DBID_METERING_PULSE_EN', options: ACS_BOOLEAN_OPTIONS },
  { name: 'DBID_METERING_FREQ', options: ACS_METERING_FREQ_OPTIONS },
  { name: 'DBID_MP_ACTIVE_TIME', options: null },
  { name: 'DBID_MP_INACTIVE_TIME', options: null },
  { name: 'DBID_METERING_AMP', options: null },
  { name: 'DBID_SRTP_ENABLE', options: ACS_BOOLEAN_OPTIONS },
  { name: 'DBID_RAS_ENABLE', options: ACS_SRTP_OPTIONS },
];

export const ACS_REBOT_MODE_OPTIONS = [
  { id: 0, name: 'Every Day' },
  { id: 1, name: 'Every Week' },
  { id: 2, name: 'Once' },
  { id: 3, name: 'Uptime Days' },
];

export const generateTimeOptions = (start: number, end: number, step: number) => {
  const options: Array<{ id: string; name: string }> = [];
  for (let i = start; i <= end; i += step) {
    options.push({ id: `${i <= 9 ? '0' : ''}${i}`, name: `${i <= 9 ? '0' : ''}${i}` });
  }
  return options;
};

export const ACS_VALUES: Array<{
  name: string;
  options: Array<{ id: number | string; name: string }> | null;
  checkbox?: boolean;
}> = [
  { name: 'PRV_DEVSTAT_SEND_PERIODIC', options: ACS_INTERVALS_OPTIONS },
  { name: 'dhcpEnabled', options: ACS_BOOLEAN_OPTIONS },
  { name: 'TZ', options: ACS_TZ_OPTIONS },
  { name: 'rebootEnable', options: ACS_BOOLEAN_OPTIONS },
  { name: 'rebootMode', options: ACS_REBOT_MODE_OPTIONS },
  { name: 'rweek', options: null, checkbox: true },
  { name: 'updays', options: null },
  { name: 'hour6', options: generateTimeOptions(0, 23, 1) },
  { name: 'min6', options: generateTimeOptions(0, 59, 1) },
  { name: 'RemoteSyslogEnable', options: ACS_BOOLEAN_OPTIONS },
  { name: 'RemoteSyslogServer', options: null },
  { name: 'DBID_SD_WAN_NETWORK_PRIORITY_0', options: ACS_WAN_OPTIONS },
  { name: 'DBID_SD_WAN_NETWORK_PRIORITY_1', options: ACS_WAN_OPTIONS },
  { name: 'DBID_SD_WAN_PING_ENABLE', options: ACS_BOOLEAN_OPTIONS },
  { name: 'DBID_SD_WAN_NETWORK_PROBING_TIME', options: null },
  { name: 'DBID_SD_WAN_PING_DESTDOMAIN', options: null },
  { name: 'DBID_SD_WAN_NETWORK_PROBING_MAX_TIMES', options: null },
  { name: 'DBID_SD_WAN_FALL_BACK', options: ACS_BOOLEAN_OPTIONS },
  { name: 'DBID_SD_WAN_FALL_BACK_TIME', options: null },
  { name: 'DBID_POE1_ENABLE', options: ACS_SWITCH_OPTIONS },
  { name: 'DBID_POE2_ENABLE', options: ACS_SWITCH_OPTIONS },
  { name: 'DBID_UPS_ENABLE', options: ACS_SWITCH_OPTIONS },
];
